export const getPageFromUrl = (): number => {
  if (typeof window === 'undefined') {
    return 1;
  }
  const urlParams = new URLSearchParams(window.location.search);
  return parseInt(urlParams.get('page') || '1');
};
